import { FieldTypes } from '../../../components/FormBuilder';

export const formInitialValues = (businessType) => {
  return {
    businessName: '',
    businessType: businessType,
    regNumber: '',
    vatNumber: ''
  };
};

export const businessName = {
  type: FieldTypes.INPUT_BLUR,
  props: {
    type: 'text',
    inputMode: 'text',
    placeholder: 'Business name',
    name: 'businessName',
    hideUnderline: true,
    disabled: false
  }
};

export const regNumber = {
  type: FieldTypes.INPUT_BLUR,
  props: {
    type: 'text',
    inputMode: 'text',
    placeholder: 'Business registration number',
    name: 'regNumber',
    hideUnderline: true,
    disabled: false
  }
};

export const vatNumber = {
  type: FieldTypes.INPUT_BLUR,
  props: {
    type: 'text',
    inputMode: 'text',
    placeholder: 'VAT number',
    name: 'vatNumber',
    hideUnderline: true,
    disabled: false
  }
};

export const getFormFields = (businessType) => {
  const fields = [
    businessName,
    businessType
  ];

  if (businessType && businessType !== 'Sole Proprietorship') {
    fields.push(regNumber);
  } else if (businessType === 'Sole Proprietorship') {
    fields.push(vatNumber);
  }
  return fields;
};